<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
<el-col :span="16">
    <el-card class="box-card" style="height:300px;" v-loading="loading">
        <div slot="header" class="clearfix">
            <!--<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
            <span>地区概况</span>
            <el-popover
                    placement="top"
                    title=""
                    width="200"
                    trigger="hover"
                    content="数据根据周报月报汇总统计">
                <el-button slot="reference" type="text" style="float:right;padding: 3px 0;color:#666;"><i class='el-icon-question'></i></el-button>
            </el-popover>
            <div class="float-r" v-show="false">
                <span class="grey-font font-12" v-if="'week'==searchType">默认所选日期往前推7天作为本周&nbsp;&nbsp;</span>
                    <el-select v-model="searchType" placeholder="按照周" size="small" @change="changeHandler" style="margin-top:-6px;margin-right:5px;">
                        <el-option
                                v-for="item in optionsThree"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                <el-date-picker v-if="searchType=='week'"
                                v-model="searchDate"
                                size="small"
                                @change="dataChange"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :editable="false"
                                :clearable="false"
                                placeholder="选择日期" style="margin-top:-6px;width:240px;">
                </el-date-picker>


                <el-date-picker  v-if="searchType=='month'"
                                 size="small"
                                 v-model="searchMouth"
                                 type="month"
                                 @change="mouthChange"
                                 value-format="yyyy-MM"
                                 :editable="false"
                                 :clearable="false"
                                 placeholder="选择月" style="margin-top:-6px;width:240px;" >
                </el-date-picker>
                </div>
        </div>
        <el-row :gutter="10" >
            <el-col :span="8">
                <el-row>
                    <el-col :span="5">
                        <div class="margin-top-20">
                            <img  style="width: 60px; height: 60px" src="@/views/board/boss/sysRoomRelevant/img/area-huanan.png" />
                        </div>
                    </el-col>
                    <el-col :span="19">
                        <div>
                            <p class="bold font-16">华南地区</p>
                            <p class="grey-font font-12">机柜总数

                                <b class="text-right float-r" style="">{{huaNanRackTotal}}</b>
                            </p>
                            <p class="grey-font font-12">机柜签约率
                                <span class="float-r bold" v-bind:class="{'red-font':isA,'green-font':isB }" style=""><i v-bind:class="{'el-icon-top':isA ,'bold':isA ,'el-icon-bottom':isB}"></i>{{huaNanRackRatioEq}}%</span>
                                <b class="text-right margin-right-10 float-r" style="margin-right: 10px;">{{huaNanRackRatio}}%</b>
                            </p>
                            <p class="grey-font font-12">生产上电
                                <span class="float-r bold" v-bind:class="{'red-font':isC,'green-font':isD }" style=""><i v-bind:class="{'el-icon-top':isC ,'bold':isC ,'el-icon-bottom':isD}"></i>{{huaNanProduceElectricityEq}}%</span>
                                <b class="text-right margin-right-10 float-r" style="margin-right: 10px;">{{huaNanProduceElectricity}}</b>
                            </p>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="8">
                <el-row>
                    <el-col :span="5">
                        <div class="margin-top-20">
                            <img  style="width: 55px; height: 55px" src="@/views/board/boss/sysRoomRelevant/img/area-huabei.png" />
                        </div>
                    </el-col>
                    <el-col :span="19">
                        <div>
                            <p class="bold font-16">华北地区</p>
                            <p class="grey-font font-12">机柜总数

                                <b class="text-right float-r" style="">{{huaBeiRackTotal}}</b>
                            </p>
                            <p class="grey-font font-12">机柜签约率
                                <span class="float-r bold" v-bind:class="{'red-font':isE,'green-font':isF }" style=""><i v-bind:class="{'el-icon-top':isE ,'bold':isE ,'el-icon-bottom':isF}"></i>{{huaBeiRackRatioEq}}%</span>
                                <b class="text-right margin-right-10 float-r" style="margin-right: 10px;">{{huaBeiRackRatio}}%</b>
                            </p>
                            <p class="grey-font font-12">生产上电
                                <span class="float-r bold" v-bind:class="{'red-font':isG,'green-font':isH }" style=""><i v-bind:class="{'el-icon-top':isG ,'bold':isG ,'el-icon-bottom':isH}"></i>{{huaBeiProduceElectricityEq}}%</span>
                                <b class="text-right margin-right-10 float-r" style="margin-right: 10px;">{{huaBeiProduceElectricity}}</b>
                            </p>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="8">
                <el-row>
                    <el-col :span="5">
                        <div class="margin-top-20">
                            <img  style="width: 57px; height: 57px" src="@/views/board/boss/sysRoomRelevant/img/area-huadong.png" />
                        </div>
                    </el-col>
                    <el-col :span="19">
                        <div>
                            <p class="bold font-16">华东地区</p>
                            <p class="grey-font font-12">机柜总数

                                <b class="text-right float-r" style="">{{huaDongRackTotal}}</b>
                            </p>
                            <p class="grey-font font-12">机柜签约率
                                <span class="float-r bold" v-bind:class="{'red-font':isI,'green-font':isJ }" style=""><i v-bind:class="{'el-icon-top':isI ,'bold':isI ,'el-icon-bottom':isJ}"></i>{{huaDongRackRatioEq}}%</span>
                                <b class="text-right margin-right-10 float-r" style="margin-right: 10px;">{{huaDongRackRatio}}%</b>
                            </p>
                            <p class="grey-font font-12">生产上电
                                <span class="float-r bold" v-bind:class="{'red-font':isK,'green-font':isL }" style=""><i v-bind:class="{'el-icon-top':isK ,'bold':isK ,'el-icon-bottom':isL}"></i>{{huaDongProduceElectricityEq}}%</span>
                                <b class="text-right margin-right-10 float-r" style="margin-right: 10px;">{{huaDongProduceElectricity}}</b>
                            </p>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <span style="font-size: 12px;float: right;color: #999;">注:上升,下降百分比是周环比或者月环比数据</span>
        </el-row>
    </el-card>
</el-col>
</template>

<script>
    import {athubAxios} from '../../../../util'
    import {COMMON_SERVER} from '@/api/server'
    import {getAllSysRoomByRunning,querySysRoomReportInfoNew,querySysRoomReportInfoOld
    } from '@/api/bossBoard/sysRoomRelevant/sysRoomBoardArea.js'
    export default {
        name: 'sysRoomBoardArea',
        components: {},
        data() {
            return {
                isA:null,//图标上下箭头
                isB:null,//图标上下箭头
                isC:null,//图标上下箭头
                isD:null,//图标上下箭头
                isE:null,//图标上下箭头
                isF:null,//图标上下箭头
                isG:null,//图标上下箭头
                isH:null,//图标上下箭头
                isI:null,//图标上下箭头
                isJ:null,//图标上下箭头
                isK:null,//图标上下箭头
                isL:null,//图标上下箭头
                imgHuaNan:require("@/views/board/boss/sysRoomRelevant/img/area-huanan.png"),
                imgHuaBei:require("@/views/board/boss/sysRoomRelevant/img/area-huabei.png"),
                imgHuaDong:require("@/views/board/boss/sysRoomRelevant/img/area-huadong.png"),
                optionsThree:[
                {'label':'周','value':'week'},
                {'label':'月','value':'month'}],
                searchType:'month',//查询周或者月
                searchDate:new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1)+ '-'+new Date().getDate(),
                searchMouth:new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1),
                sysRoomAll:[],//区域（华南华北华中）的所有数据中心
                sysRoomAllMap:null,//把查询出来区域（华南华北华中）的所有数据中心转成MAP，用来获取里面的属于哪一个区域
                sysRoomAreaHuaNan:[],//华南的数据中心的dcNum集合
                sysRoomAreaHuaBei:[],//华北的数据中心的dcNum集合
                sysRoomAreaHuaDong:[],//华东的数据中心的dcNum集合
                huaNanRackTotal:null,//华南机柜总数
                huaDongRackTotal:null,//华东机柜总数
                huaBeiRackTotal:null,//华北机柜总数
                huaNanRackRatio:null,//华南机柜签约率
                huaDongRackRatio:null,//华东机柜签约率
                huaBeiRackRatio:null,//华北机柜签约率
                huaNanProduceElectricity:null,//华南生产上电
                huaDongProduceElectricity:null,//华东生产上电
                huaBeiProduceElectricity:null,//华北生产上电
                huaNanRackRatioEq:null,//华南机柜签约率和上周比
                huaNanProduceElectricityEq:null,//华南生产上电和上周比
                huaBeiRackRatioEq:null,//华北机柜签约率和上周比
                huaBeiProduceElectricityEq:null,//华北生产上电和上周比
                huaDongRackRatioEq:null,//华东机柜签约率和上周比
                huaDongProduceElectricityEq:null,//华东生产上电和上周比
                loading:true
            }
        },
        methods: {
            addZero(num) {
                if (parseInt(num) < 10) {
                    num = '0' + num;
                }
                return num;
            },
            //选择周月促发事件
            async changeHandler(boo){
                this.loading=true;
                //先清空数据
                this.huaNanRackTotal=null;//华南机柜总数
                this.huaNanRackRatio=null;//华南机柜签约率
                this.huaNanProduceElectricity=null;//华南生产上电

                this.huaDongRackTotal=null;//华东机柜总数
                this.huaDongRackRatio=null;//华东机柜签约率
                this.huaDongProduceElectricity=null;//华南生产上电

                this.huaBeiRackTotal=null;//华北机柜总数
                this.huaBeiRackRatio=null;//华北机柜签约率
                this.huaBeiProduceElectricity=null;//华南生产上电

                this.sysRoomAreaHuaNan=[];
                this.sysRoomAreaHuaDong=[];
                this.sysRoomAreaHuaBei=[];

                this.huaNanRackRatioEq=null;//华南机柜签约率和上周比
                this.huaNanProduceElectricityEq=null;//华南生产上电和上周比
                this.huaBeiRackRatioEq=null;//华北机柜签约率和上周比
                this.huaBeiProduceElectricityEq=null;//华北生产上电和上周比
                this.huaDongRackRatioEq=null;//华东机柜签约率和上周比
                this.huaDongProduceElectricityEq=null;//华东生产上电和上周比

                //周月下拉框缩起来促发事件
//                if (boo == false) {
                    if(this.searchType=='week'){//周

                        //环比  上周和这周
                        var date=new Date(this.searchDate);

                        var topWeekOld=new Date(date);//上周最后一天
                        topWeekOld.setDate(topWeekOld.getDate()-7);
//                        var topWeekFirst=new Date(topWeekOld);//上周第一天
//                        topWeekFirst.setDate(topWeekFirst.getDate()-7);

//                        var thisWeekFirst=new Date(date);//本周第一天
//                        thisWeekFirst.setDate(thisWeekFirst.getDate()-7);
                        //本周最后一天其实就是this.searchDate
//                        var topWeekOldStr=topWeekOld.getFullYear()+'-'+this.addZero(topWeekOld.getMonth()+1)+'-'+this.addZero(topWeekOld.getDate());
//                        var topWeekFirstStr=topWeekFirst.getFullYear()+'-'+this.addZero(topWeekFirst.getMonth()+1)+'-'+this.addZero(topWeekFirst.getDate());
//
//                        var thisWeekFirstStr=thisWeekFirst.getFullYear()+'-'+this.addZero(thisWeekFirst.getMonth()+1)+'-'+this.addZero(thisWeekFirst.getDate());
//                        var thisWeekOldStr=date.getFullYear()+'-'+this.addZero(date.getMonth()+1)+'-'+this.addZero(date.getDate());

//                        var topWeekOldStrLong=new Date(topWeekOldStr);
//                        var topWeekFirstStrLong=new Date(topWeekFirstStr);
//                        var thisWeekFirstStrLong=new Date(thisWeekFirstStr);
//                        var thisWeekOldStrLong=new Date(thisWeekOldStr);

                        // 先循环把查询出来的SYSROOM 判断出对应的是哪一个区域的数据中心
                        this.sysRoomAll.forEach(c =>{
                            if(c.areaCode=='southChina'){//华南
                                this.sysRoomAreaHuaNan.push(c.dcNum);
                            }else if(c.areaCode=='eastChina'){//华东
                                this.sysRoomAreaHuaDong.push(c.dcNum);
                            }else{//华北northChina
                                this.sysRoomAreaHuaBei.push(c.dcNum);
                            }
                        })

                        // 调用后台查询出来的数据华南,华北，华东存放位置
                        var allDcnumReportPromiseHuaNan=[];
                        var allDcnumReportPromiseHuaDong=[];
                        var allDcnumReportPromiseHuaBei=[];

                        //先查询本周
                        var sp = {
                            "startTimeEnd": new Date(date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate()).getTime(),
                            "endTimeStart": new Date(date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate()).getTime(),
                            "woType": 'WEEKLY',
                            "paging": false
                        }

                        //获取华南数据
                        for (var i = 0; i < this.sysRoomAreaHuaNan.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaNan[i]];
                            //oneDcnumSP.dcnum = this.sysRoomAreaHuaNan;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data = await querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaNan.push(data);
                            }
                        }
                        //获取华东数据
                        for (var i = 0; i < this.sysRoomAreaHuaDong.length; i++) {

                            var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaDong[i]];
//                            oneDcnumSP.dcnum = this.sysRoomAreaHuaDong;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data = await querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaDong.push(data);
                            }
                        }

                        //获取华北数据
                        for (var i = 0; i < this.sysRoomAreaHuaBei.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaBei[i]];
//                            oneDcnumSP.dcnum = this.sysRoomAreaHuaBei;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data = await querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaBei.push(data);
                            }
                        }

                        //判断三个数组是不是没有数据如果没有数据，直接查询上一周数据
                        var allDcnumReportPromiseHuaNanSize=0;
                        var allDcnumReportPromiseHuaDongSize=0;
                        var allDcnumReportPromiseHuaBeiSize=0;
                        for(var a=0;a<allDcnumReportPromiseHuaNan.length;a++){
                            if(allDcnumReportPromiseHuaNan[a].length>0){
                                allDcnumReportPromiseHuaNanSize+=1;
                            }
                        }
                        for(var a=0;a<allDcnumReportPromiseHuaDong.length;a++){
                            if(allDcnumReportPromiseHuaDong[a].length>0){
                                allDcnumReportPromiseHuaDongSize+=1;
                            }
                        }
                        for(var a=0;a<allDcnumReportPromiseHuaBei.length;a++){
                            if(allDcnumReportPromiseHuaBei[a].length>0){
                                allDcnumReportPromiseHuaBeiSize+=1;
                            }
                        }
                        if(allDcnumReportPromiseHuaNanSize==0&&allDcnumReportPromiseHuaDongSize==0&&allDcnumReportPromiseHuaBeiSize==0){
                            var allDcnumReportPromiseHuaNan=[];
                            var allDcnumReportPromiseHuaDong=[];
                            var allDcnumReportPromiseHuaBei=[];
                            var sp = {
                                "startTimeEnd": new Date(topWeekOld.getFullYear()+'/'+(topWeekOld.getMonth()+1)+'/'+topWeekOld.getDate()).getTime(),
                                "endTimeStart": new Date(topWeekOld.getFullYear()+'/'+(topWeekOld.getMonth()+1)+'/'+topWeekOld.getDate()).getTime(),
                                "woType": 'WEEKLY',
                                "paging": false
                            }
                            //获取华南数据
                            for (var i = 0; i < this.sysRoomAreaHuaNan.length; i++) {
                                var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                                oneDcnumSP.dcnum = [this.sysRoomAreaHuaNan[i]];
                                //oneDcnumSP.dcnum = this.sysRoomAreaHuaNan;
                                var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                                var data =  querySysRoomReportInfoOld(queryString);
                                if(null!=data){
                                    allDcnumReportPromiseHuaNan.push(data);
                                }
                            }
                            //获取华东数据
                            for (var i = 0; i < this.sysRoomAreaHuaDong.length; i++) {

                                var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                                oneDcnumSP.dcnum = [this.sysRoomAreaHuaDong[i]];
//                            oneDcnumSP.dcnum = this.sysRoomAreaHuaDong;
                                var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                                var data =  querySysRoomReportInfoOld(queryString);
                                if(null!=data){
                                    allDcnumReportPromiseHuaDong.push(data);
                                }
                            }

                            //获取华北数据
                            for (var i = 0; i < this.sysRoomAreaHuaBei.length; i++) {
                                var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                                oneDcnumSP.dcnum = [this.sysRoomAreaHuaBei[i]];
//                            oneDcnumSP.dcnum = this.sysRoomAreaHuaBei;
                                var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                                var data =  querySysRoomReportInfoOld(queryString);
                                if(null!=data){
                                    allDcnumReportPromiseHuaBei.push(data);
                                }
                            }
                        }




                        //上面查询数据都是异步的这边用promise.all 判定全部获取到数据之后执行
                        Promise.all( allDcnumReportPromiseHuaNan).then((values) => {
                            //计算华南机柜总数和机柜签约率
                            var huaNan=this.baicalculate(values);
                            this.huaNanRackTotal=huaNan.rackTotal;//华南机柜总数
                            this.huaNanRackRatio=huaNan.rackRatio;//华南机柜签约率
                            this.huaNanProduceElectricity=huaNan.produceElectricity;//华南生产上电
                        });
                        Promise.all( allDcnumReportPromiseHuaDong).then((values) => {
                            //计算华东机柜总数和机柜签约率
                            var huaDong=this.baicalculate(values);
                            this.huaDongRackTotal=huaDong.rackTotal;//华东机柜总数
                            this.huaDongRackRatio=huaDong.rackRatio;//华东机柜签约率
                            this.huaDongProduceElectricity=huaDong.produceElectricity;//华东生产上电
                        });
                        Promise.all( allDcnumReportPromiseHuaBei).then((values) => {
                            //计算华北机柜总数和机柜签约率
                            var huaBei=this.baicalculate(values);
                            this.huaBeiRackTotal=huaBei.rackTotal;//华北机柜总数
                            this.huaBeiRackRatio=huaBei.rackRatio;//华北机柜签约率
                            this.huaBeiProduceElectricity=huaBei.produceElectricity;//华北生产上电
                        });



                        //在查询上周

                        // 调用后台查询出来的数据华南,华北，华东存放位置
                        var allDcnumReportPromiseHuaNan1=[];
                        var allDcnumReportPromiseHuaDong1=[];
                        var allDcnumReportPromiseHuaBei1=[];
                        var sp1 = {
                            "startTimeEnd": new Date(topWeekOld.getFullYear()+'/'+(topWeekOld.getMonth()+1)+'/'+topWeekOld.getDate()).getTime(),
                            "endTimeStart": new Date(topWeekOld.getFullYear()+'/'+(topWeekOld.getMonth()+1)+'/'+topWeekOld.getDate()).getTime(),
                            "woType": 'WEEKLY',
                            "paging": false
                        }

                        //获取华南数据
                        for (var i = 0; i < this.sysRoomAreaHuaNan.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp1));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaNan[i]];
                            //oneDcnumSP.dcnum = this.sysRoomAreaHuaNan;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data = querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaNan1.push(data);
                            }
                        }
                        //获取华东数据
                        for (var i = 0; i < this.sysRoomAreaHuaDong.length; i++) {

                            var oneDcnumSP = JSON.parse(JSON.stringify(sp1));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaDong[i]];
                            //oneDcnumSP.dcnum = this.sysRoomAreaHuaDong;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data = querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaDong1.push(data);
                            }
                        }

                        //获取华北数据
                        for (var i = 0; i < this.sysRoomAreaHuaBei.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp1));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaBei[i]];
                            //oneDcnumSP.dcnum = this.sysRoomAreaHuaBei;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data = querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaBei1.push(data);
                            }
                        }


                        //上面查询数据都是异步的这边用promise.all 判定全部获取到数据之后执行
                        Promise.all( allDcnumReportPromiseHuaNan1).then((values) => {
                            //计算华南机柜签约率和生产上电
                            var huaNan1=this.baicalculate(values);
                            this.huaNanRackRatioEq=(((this.huaNanRackRatio-huaNan1.rackRatio)/huaNan1.rackRatio)*100).toFixed(2);//华南机柜签约率和上周比
                            this.huaNanProduceElectricityEq=((this.huaNanProduceElectricity-huaNan1.produceElectricity)/huaNan1.produceElectricity*100).toFixed(2);//华南生产上电和上周比
                            if(this.huaNanRackRatioEq>0){
                                this.isA=true;
                                this.isB=false;

                            }else if(this.huaNanRackRatioEq<0){
                                this.isA=false;
                                this.isB=true;
                                //负数转正数
                                this.huaNanRackRatioEq=Math.abs(this.huaNanRackRatioEq);
                            }else{
                                this.isA=false;
                                this.isB=false;
                                this.huaNanRackRatioEq='-';
                            }
                            if(this.huaNanProduceElectricityEq>0){
                                this.isC=true;
                                this.isD=false;
                            }else if(this.huaNanProduceElectricityEq<0){
                                this.isC=false;
                                this.isD=true;
                                //负数转正数
                                this.huaNanProduceElectricityEq=Math.abs(this.huaNanProduceElectricityEq);
                            }else{
                                this.isC=false;
                                this.isD=false;
                                this.huaNanProduceElectricityEq='-';
                            }


                        });
                        Promise.all( allDcnumReportPromiseHuaDong1).then((values) => {
                            //计算华东机柜签约率和生产上电
                            var huaDong1=this.baicalculate(values);

                            this.huaDongRackRatioEq=(((this.huaDongRackRatio-huaDong1.rackRatio)/huaDong1.rackRatio)*100).toFixed(2);//华东机柜签约率和上周比
                            this.huaDongProduceElectricityEq=((this.huaDongProduceElectricity-huaDong1.produceElectricity)/huaDong1.produceElectricity*100).toFixed(2);//华东生产上电和上周比
                            if(this.huaDongRackRatioEq>0){
                                this.isI=true;
                                this.isJ=false;
                            }else if(this.huaDongRackRatioEq<0){
                                this.isI=false;
                                this.isJ=true;
                                //负数转正数
                                this.huaDongRackRatioEq=Math.abs(this.huaDongRackRatioEq);
                            }else{
                                this.isI=false;
                                this.isJ=false;
                                this.huaDongRackRatioEq='-';
                            }
                            if(this.huaDongProduceElectricityEq>0){
                                this.isK=true;
                                this.isL=false;
                            }else if(this.huaDongProduceElectricityEq<0){
                                this.isK=false;
                                this.isL=true;
                                //负数转正数
                                this.huaDongProduceElectricityEq=Math.abs(this.huaDongProduceElectricityEq);
                            }else{
                                this.isK=false;
                                this.isL=false;
                                this.huaDongProduceElectricityEq='-';
                            }


                        });
                        Promise.all( allDcnumReportPromiseHuaBei1).then((values) => {
                            //计算华北机柜签约率和生产上电
                            var huaBei1=this.baicalculate(values);
                            this.huaBeiRackRatioEq=(((this.huaBeiRackRatio-huaBei1.rackRatio)/huaBei1.rackRatio)*100).toFixed(2);//华北机柜签约率和上周比
                            this.huaBeiProduceElectricityEq=((this.huaBeiProduceElectricity-huaBei1.produceElectricity)/huaBei1.produceElectricity*100).toFixed(2);//华北生产上电和上周比
                            if(this.huaBeiRackRatioEq>0){
                                this.isE=true;
                                this.isF=false;
                            }else if(this.huaBeiRackRatioEq<0){
                                this.isE=false;
                                this.isF=true;
                                //负数转正数
                                this.huaBeiRackRatioEq=Math.abs(this.huaBeiRackRatioEq);
                            }else{
                                this.isE=false;
                                this.isF=false;

                                this.huaBeiRackRatioEq='-';
                            }
                            if(this.huaBeiProduceElectricityEq>0){
                                this.isG=true;
                                this.isH=false;
                            }else if(this.huaBeiProduceElectricityEq<0){
                                this.isG=false;
                                this.isH=true;
                                //负数转正数
                                this.huaBeiProduceElectricityEq=Math.abs(this.huaBeiProduceElectricityEq);
                            }else{
                                this.isG=false;
                                this.isH=false;
                                this.huaBeiProduceElectricityEq='-';
                            }

                        this.loading=false;
                        });


                    }else{//月

                        // 调用后台查询出来的数据华南,华北，华东存放位置
                        var allDcnumReportPromiseHuaNan=[];
                        var allDcnumReportPromiseHuaDong=[];
                        var allDcnumReportPromiseHuaBei=[];
                        //环比  上月和这月
                        var date=new Date(this.searchMouth);


                        date.setMonth(date.getMonth()-1);

                        //上月第一天
                        var topMonthFirst = new Date(this.getTheMonthFirstLastDay(date.getFullYear()+'-'+this.addZero(date.getMonth()+1) + "-01", (
                                'yyyy-MM-dd hh:mm:ss'))[0]);
                        //上月最后一天
                        var topMonthOld = new Date(this.getTheMonthFirstLastDay(date.getFullYear()+'-'+this.addZero(date.getMonth()+1) + "-01", (
                                'yyyy-MM-dd hh:mm:ss'))[1]);


                        //本月第一天
                        var thisMonthFirst = new Date(this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd hh:mm:ss'))[0]);
                        //本月最后一天
                        var thisMonthOld = new Date(this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd hh:mm:ss'))[1]);



//                        var topMonthOldStr=topMonthOld.getFullYear()+'-'+this.addZero(topMonthOld.getMonth()+1)+'-'+this.addZero(topMonthOld.getDate());
//                        var topMonthFirstStr=topMonthFirst.getFullYear()+'-'+this.addZero(topMonthFirst.getMonth()+1)+'-'+this.addZero(topMonthFirst.getDate());

//                        var thisMonthFirstStr=thisMonthFirst.getFullYear()+'-'+this.addZero(thisMonthFirst.getMonth()+1)+'-'+this.addZero(thisMonthFirst.getDate());
//                        var thisMonthOldStr=thisMonthOld.getFullYear()+'-'+this.addZero(thisMonthOld.getMonth()+1)+'-'+this.addZero(thisMonthOld.getDate());

//                        var topMonthOldStrLong=new Date(topMonthOldStr);
//                        var topMonthFirstStrLong=new Date(topMonthFirstStr);
//                        var thisMonthFirstStrLong=new Date(thisMonthFirstStr);
//                        var thisMonthOldStrLong=new Date(thisMonthOldStr);

                        // 先循环把查询出来的SYSROOM 判断出对应的是哪一个区域的数据中心
                        this.sysRoomAll.forEach(c =>{
                            if(c.areaCode=='southChina'){//华南
                            this.sysRoomAreaHuaNan.push(c.dcNum);
                        }else if(c.areaCode=='eastChina'){//华东
                            this.sysRoomAreaHuaDong.push(c.dcNum);
                        }else{//华北northChina
                            this.sysRoomAreaHuaBei.push(c.dcNum);
                        }
                    })

                        //先查询本月
                        var now = new Date();
                        var yearOfNow = now.getFullYear();
                        var monthOfNow = now.getMonth() + 1;
                        var dateOfNow = now.getDate();

                        var nowDate = new Date(yearOfNow + "/" + monthOfNow + "/" + dateOfNow);
                        if (monthOfNow == new Date(this.searchMouth).getMonth()+1) {//月份相等，那就是最大能选择得月份，取向上一周得周报数据
                            if((now.getDay()==1||now.getDay()==2||now.getDay()==3||now.getDay()==4)&&(
                                            dateOfNow==1&&dateOfNow==2&&dateOfNow==3&&dateOfNow!=4
                                    )){

                                var sp = {
                                    "startTime": topMonthFirst.getTime(),
                                    "endTime": topMonthOld.getTime(),
                                    "woType": 'MONTHLY',
                                    "paging": false
                                }

                            }else{
                                //查询当前日期减去七天
                                var topSevenDate=new Date(nowDate);//上周最后一天
                                topSevenDate.setDate(topSevenDate.getDate()-7);
                                var sp = {
                                    "startTimeEnd": topSevenDate.getTime(),
                                    "endTimeStart": topSevenDate.getTime(),
                                    "woType": 'WEEKLY',
                                    "paging": false
                                }
                            }
                        }else{
                            var sp = {
                                "startTime": thisMonthFirst.getTime(),
                                "endTime": thisMonthOld.getTime(),
                                "woType": 'MONTHLY',
                                "paging": false
                            }
                        }

                        //获取华南数据
                        for (var i = 0; i < this.sysRoomAreaHuaNan.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaNan[i]];
                            //oneDcnumSP.dcnum = this.sysRoomAreaHuaNan;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data =  querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaNan.push(data);
                            }
                        }
                        //获取华东数据
                        for (var i = 0; i < this.sysRoomAreaHuaDong.length; i++) {

                            var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaDong[i]];
                            //oneDcnumSP.dcnum = this.sysRoomAreaHuaDong;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data =  querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaDong.push(data);
                            }
                        }

                        //获取华北数据
                        for (var i = 0; i < this.sysRoomAreaHuaBei.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaBei[i]];
                           // oneDcnumSP.dcnum = this.sysRoomAreaHuaBei;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data =  querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaBei.push(data);
                            }
                        }

                        //上面查询数据都是异步的这边用promise.all 判定全部获取到数据之后执行
                        Promise.all( allDcnumReportPromiseHuaNan).then((values) => {
                            //计算华南机柜总数和机柜签约率
                            var huaNan=this.baicalculate(values);
                            this.huaNanRackTotal=huaNan.rackTotal;//华南机柜总数
                            this.huaNanRackRatio=huaNan.rackRatio;//华南机柜签约率
                            this.huaNanProduceElectricity=huaNan.produceElectricity;//华南生产上电
                        });
                        Promise.all( allDcnumReportPromiseHuaDong).then((values) => {
                            //计算华东机柜总数和机柜签约率
                            var huaDong=this.baicalculate(values);
                            this.huaDongRackTotal=huaDong.rackTotal;//华东机柜总数
                            this.huaDongRackRatio=huaDong.rackRatio;//华东机柜签约率
                            this.huaDongProduceElectricity=huaDong.produceElectricity;//华东生产上电
                        });
                        Promise.all( allDcnumReportPromiseHuaBei).then((values) => {
                            //计算华北机柜总数和机柜签约率
                            var huaBei=this.baicalculate(values);
                            this.huaBeiRackTotal=huaBei.rackTotal;//华北机柜总数
                            this.huaBeiRackRatio=huaBei.rackRatio;//华北机柜签约率
                            this.huaBeiProduceElectricity=huaBei.produceElectricity;//华北生产上电
                        });




                        //在查询上月

                        // 调用后台查询出来的数据华南,华北，华东存放位置
                        var allDcnumReportPromiseHuaNan1=[];
                        var allDcnumReportPromiseHuaDong1=[];
                        var allDcnumReportPromiseHuaBei1=[];

                        var sp1 = {
                            "startTime": topMonthFirst.getTime(),
                            "endTime": topMonthOld.getTime(),
                            "woType": 'MONTHLY',
                            "paging": false
                        }

                        //获取华南数据
                        for (var i = 0; i < this.sysRoomAreaHuaNan.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp1));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaNan[i]];
//                            oneDcnumSP.dcnum = this.sysRoomAreaHuaNan;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data =  querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaNan1.push(data);
                            }
                        }
                        //获取华东数据
                        for (var i = 0; i < this.sysRoomAreaHuaDong.length; i++) {

                            var oneDcnumSP = JSON.parse(JSON.stringify(sp1));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaDong[i]];
//                            oneDcnumSP.dcnum = this.sysRoomAreaHuaDong;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data =  querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaDong1.push(data);
                            }
                        }

                        //获取华北数据
                        for (var i = 0; i < this.sysRoomAreaHuaBei.length; i++) {
                            var oneDcnumSP = JSON.parse(JSON.stringify(sp1));
                            oneDcnumSP.dcnum = [this.sysRoomAreaHuaBei[i]];
//                            oneDcnumSP.dcnum = this.sysRoomAreaHuaBei;
                            var queryString = encodeURIComponent(JSON.stringify(oneDcnumSP));
                            var data =  querySysRoomReportInfoOld(queryString);
                            if(null!=data){
                                allDcnumReportPromiseHuaBei1.push(data);
                            }
                        }


                        Promise.all( allDcnumReportPromiseHuaNan1).then((values) => {

                            //计算华南机柜总数和机柜签约率
                            var huaNan1=this.baicalculate(values);
                            this.huaNanRackRatioEq=(((this.huaNanRackRatio-huaNan1.rackRatio)/huaNan1.rackRatio)*100).toFixed(2);//华南机柜签约率和上周比
                            this.huaNanProduceElectricityEq=((this.huaNanProduceElectricity-huaNan1.produceElectricity)/huaNan1.produceElectricity*100).toFixed(2);//华南生产上电和上周比
                            if(this.huaNanRackRatioEq>0){
                                this.isA=true;
                                this.isB=false;
                            }else if(this.huaNanRackRatioEq<0){
                                this.isA=false;
                                this.isB=true;
                                //负数转正数
                                this.huaNanRackRatioEq=Math.abs(this.huaNanRackRatioEq);
                            }else{
                                this.isA=false;
                                this.isB=false;
                                this.huaNanRackRatioEq='-';
                            }
                            if(this.huaNanProduceElectricityEq>0){
                                this.isC=true;
                                this.isD=false;
                            }else if(this.huaNanProduceElectricityEq<0){
                                this.isC=false;
                                this.isD=true;
                                //负数转正数
                                this.huaNanProduceElectricityEq=Math.abs(this.huaNanProduceElectricityEq);
                            }else{
                                this.isC=false;
                                this.isD=false;
                                this.huaNanProduceElectricityEq='-';
                            }


                        });
                        Promise.all( allDcnumReportPromiseHuaDong1).then((values) => {

                            //计算华东机柜总数和机柜签约率
                            var huaDong1=this.baicalculate(values);
                            this.huaDongRackRatioEq=(((this.huaDongRackRatio-huaDong1.rackRatio)/huaDong1.rackRatio)*100).toFixed(2);//华东机柜签约率和上周比
                            this.huaDongProduceElectricityEq=((this.huaDongProduceElectricity-huaDong1.produceElectricity)/huaDong1.produceElectricity*100).toFixed(2);//华东生产上电和上周比
                            if(this.huaDongRackRatioEq>0){
                                this.isI=true;
                                this.isJ=false;
                            }else if(this.huaDongRackRatioEq<0){
                                this.isI=false;
                                this.isJ=true;
                                //把负数转成正数
                                this.huaDongRackRatioEq=Math.abs(this.huaDongRackRatioEq);
                            }else{
                                this.isI=false;
                                this.isJ=false;
                                this.huaDongRackRatioEq='-';
                            }
                            if(this.huaDongProduceElectricityEq>0){
                                this.isK=true;
                                this.isL=false;
                            }else if(this.huaDongProduceElectricityEq<0){
                                this.isK=false;
                                this.isL=true;
                                //负数转正数
                                this.huaDongProduceElectricityEq=Math.abs(this.huaDongProduceElectricityEq);
                            }else{
                                this.isK=false;
                                this.isL=false;
                                this.huaDongProduceElectricityEq='-';
                            }


                        });
                        Promise.all( allDcnumReportPromiseHuaBei1).then((values) => {

                            //计算华北机柜总数和机柜签约率
                            var huaBei1=this.baicalculate(values);
                            this.huaBeiRackRatioEq=(((this.huaBeiRackRatio-huaBei1.rackRatio)/huaBei1.rackRatio)*100).toFixed(2);//华北机柜签约率和上周比
                            this.huaBeiProduceElectricityEq=((this.huaBeiProduceElectricity-huaBei1.produceElectricity)/huaBei1.produceElectricity*100).toFixed(2);//华北生产上电和上周比
                            if(this.huaBeiRackRatioEq>0){
                                this.isE=true;
                                this.isF=false;
                            }else if(this.huaBeiRackRatioEq<0){
                                this.isE=false;
                                this.isF=true;
                                //把负数转成正数
                                this.huaBeiRackRatioEq=Math.abs(this.huaBeiRackRatioEq);
                            }else{
                                this.isE=false;
                                this.isF=false;
                                this.huaBeiRackRatioEq='-';
                            }
                            if(this.huaBeiProduceElectricityEq>0){
                                this.isG=true;
                                this.isH=false;
                            }else if(this.huaBeiProduceElectricityEq<0){
                                this.isG=false;
                                this.isH=true;
                                //负数转正数
                                this.huaBeiProduceElectricityEq=Math.abs(this.huaBeiProduceElectricityEq);
                            }else{
                                this.isG=false;
                                this.isH=false;
                                this.huaBeiProduceElectricityEq='-';
                            }

                        this.loading=false;
                        });

                    }
//                }

            },
            //计算华南,华北，华中数据
            baicalculate(array){
                //计算
                var totalSaled = 0;
                var totalUnsaled = 0;
                var rackReports = [];

                if (array && array.length > 0) {
                    array.forEach(
                            function (reports) {
                                rackReports = rackReports.concat(reports);
                            }
                    )

                    //数据转换成rackReports数组里面一个一个实体然后循环计算
                    if (rackReports && rackReports.length > 0) {

                        //计算生产上电
                        var returnInfo=this.calculationElectric(rackReports);

                        for (var i = 0; i < rackReports.length; i++) {
                            var rackReport = rackReports[i].rackReport;
                            if (rackReport && rackReport.unsaled) {
                                for (var j = 0; j < rackReport.unsaled.length; j++) {

                                    var oneUnsaled = rackReport.unsaled[j];

                                    var rackTakeAtEnding = oneUnsaled.rackTakeAtEnding;

                                    totalUnsaled += parseInt(rackTakeAtEnding);
                                }
                            }

                            if (rackReport && rackReport.saled) {
                                for (var j = 0; j < rackReport.saled.length; j++) {

                                    var oneSaled = rackReport.saled[j];

                                    var rackTakeAtEnding = oneSaled.rackTakeAtEnding;

                                    totalSaled += parseInt(rackTakeAtEnding);
                                }
                            }
                        }

                        var rackTotal = totalSaled + totalUnsaled;
                        var signRack = totalSaled;
                        var rackRatio = ((totalSaled / (totalSaled + totalUnsaled)) * 100).toFixed(2);
                        return {
                            'rackTotal':rackTotal,
                           // 'signRack':signRack,
                            'rackRatio':rackRatio,
                            'produceElectricity':returnInfo.onNumber
                        };
                    }
                }

            },
            //获取当前年月日时间，月出（一号）到月末（31/30号）
            getTheMonthFirstLastDay(dateStr, fmt){
                var date = new Date(dateStr);
                var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                return [firstDay.Format(fmt), lastDay.Format(fmt)];
            },
            //计算数据中心机柜上电情况
            calculationElectric(rackReports){
                //rackReports  是上面循环获取好的月报表数据,所有信息都在里面
                if( rackReports && rackReports.length >= 0 ){
                    var totalInfo = [];//下面循环获取的值存放地
                    for( var i=0;i<rackReports.length;i++ ){
                        var reportWo   = rackReports[i];
                        var rackReport = reportWo.rackReport;
                        if( rackReport ){
                            if( rackReport.total ){
                                var oneTotal =  rackReport.total;

                                totalInfo.push(
                                        {
                                            "dcnum"                 : reportWo.dcnum                             ,
                                            "siteId"                : reportWo.siteId                            ,
                                            "onNumber"              : oneTotal.rackPowerOnProductionAtEnding     ,
                                        }
                                );
                            }
                        }
                    }


                    //分组
                    var map = new Map();
                    for(var n=0;n<totalInfo.length;n++){
                        if(map.get(totalInfo[n].siteId)){
                            var value=map.get(totalInfo[n].siteId);
                            var totalInfoNew=totalInfo[n];
                            value.onNumber=value.onNumber+totalInfoNew.onNumber;
                            map.set(value.siteId,value);
                        }else{
                            var totalInfoNew=JSON.parse(JSON.stringify(totalInfo[n]));
                            map.set(totalInfo[n].siteId,totalInfoNew);
                        }
                    }
                    //map转集合
                    var sitemGroupedTotalInfo = [];
                    sitemGroupedTotalInfo=[...map.values()];

                    //在把一条一条的集合，相同字段的数据相加组成一条数据
                    totalInfo={
                        "onNumber"              : 0,
                    }
                    for(var m=0;m<sitemGroupedTotalInfo.length;m++){
                        totalInfo.onNumber=sitemGroupedTotalInfo[m].onNumber+totalInfo.onNumber;
                    }

                    //返回数据
                    return totalInfo;

                }
            },

            //选择日期促发事件
            dataChange(){
                this.changeHandler(false);
            },
            mouthChange(){
                this.changeHandler(false);
            },
        },
        created(){


        },
        async mounted() {
            this.sysRoomAllMap = new Map();
            //页面加载先提前获取状态是 running 的数据中心
            this.sysRoomAll=await getAllSysRoomByRunning();

            this.sysRoomAll.forEach(e =>{
                this.sysRoomAllMap.set(e.dcNum,e.areaCode)
            })

        }
    }
</script>

